
var id = "updateImg";
var markup = "<symbol viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"updateImg\">\n    <title>Group</title>\n    <defs>\n        <path d=\"M2.28571429,7 L5.71428571,7 L5.71428571,3.76923077 L8,3.76923077 L4,0 L0,3.76923077 L2.28571429,3.76923077 L2.28571429,7 Z M0,8 L8,8 L8,9.5 L0,9.5 L0,8 Z\" id=\"updateImg_path-1\" />\n    </defs>\n    <g id=\"updateImg_营销活动（fa）\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"updateImg_Group-2\" transform=\"translate(-6.000000, -6.000000)\">\n            <g id=\"updateImg_Group\" transform=\"translate(6.000000, 6.000000)\">\n                <path d=\"M10,0 C4.477,0 0,4.477 0,10 C0,15.523 4.477,20 10,20 C15.523,20 20,15.523 20,10 C20,4.477 15.523,0 10,0 Z M10,18 C5.582,18 2,14.418 2,10 C2,5.582 5.582,2 10,2 C14.418,2 18,5.582 18,10 C18,14.418 14.418,18 10,18 Z\" id=\"updateImg_形状-copy-2\" fill=\"#FFFFFF\" fill-rule=\"nonzero\" />\n                <g id=\"updateImg_filled/file/attachment_24px\" transform=\"translate(6.000000, 5.000000)\">\n                    <mask id=\"updateImg_mask-2\" fill=\"white\">\n                        <use xlink:href=\"#updateImg_path-1\" />\n                    </mask>\n                    <g id=\"updateImg_icon/file/upload_24px\" fill-rule=\"nonzero\"></g>\n                    <g id=\"updateImg_Group\" mask=\"url(#updateImg_mask-2)\">\n                        <g transform=\"translate(-2.000000, -1.000000)\" id=\"updateImg_↳-Color\">\n                            <rect id=\"updateImg_Rectangle\" fill=\"#FFFFFF\" x=\"0\" y=\"0\" width=\"12\" height=\"12\" />\n                        </g>\n                    </g>\n                </g>\n            </g>\n        </g>\n    </g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
